// import _ from 'lodash'

class Slide {
  constructor(data) {
    this.start = data.start
    this.end = data.end
    this.src = data.src
  }
}

export default Slide;
